import { render } from "./ModuleLayout.vue?vue&type=template&id=607ebd58&ts=true"
import script from "./ModuleLayout.vue?vue&type=script&lang=ts"
export * from "./ModuleLayout.vue?vue&type=script&lang=ts"

import "./ModuleLayout.vue?vue&type=style&index=0&id=607ebd58&lang=css"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__